import React from 'react';
import { Pill, type DataTableColumn, type PdfTone } from '../../../utils/pdf';
import type { ExportColumn } from '../../../utils/admissionRecords';

/** A list's export columns as the PDF table draws them: only those marked for print, the status as a pill. */
export function exportPdfColumns<Row>(columns: Array<ExportColumn<Row>>, statusTone: (row: Row) => PdfTone): Array<DataTableColumn<Row>> {
  return columns.filter(c => c.pdf).map(c => ({
    key: c.header,
    header: c.header,
    width: c.pdf!.width,
    flex: c.pdf!.flex,
    align: c.pdf!.align,
    render: (row: Row) => {
      const v = c.value(row);
      if (c.isStatus) return <Pill dense label={String(v)} tone={statusTone(row)} />;
      return v == null || v === '' ? '—' : String(v);
    },
  }));
}
